import React from "react";

export default function Privacy() {
  return (
    <div style={{ maxWidth: "800px", margin: "40px auto", padding: "20px", lineHeight: "1.6" }}>
      <h1>Privacy Policy</h1>

      <p>
        We value your privacy. This Privacy Policy explains how we collect, use,
        and protect your information when you use our AI travel platform.
      </p>

      <h2>1. Information We Collect</h2>
      <ul>
        <li>Username and account details</li>
        <li>Travel notices (country, dates)</li>
        <li>Transaction data for fraud detection</li>
        <li>Device and usage information</li>
      </ul>

      <h2>2. How We Use Your Data</h2>
      <ul>
        <li>To provide AI-powered travel recommendations</li>
        <li>To detect and prevent fraudulent transactions</li>
        <li>To improve system performance and accuracy</li>
      </ul>

      <h2>3. Data Sharing</h2>
      <p>
        We do not sell your personal data. Data may be shared with secure
        service providers (e.g. database or AI model hosting) only for app functionality.
      </p>

      <h2>4. Data Security</h2>
      <p>
        We use encryption, secure APIs, and authentication to protect your data.
      </p>

      <h2>5. Your Rights</h2>
      <p>
        You may request deletion of your data or account at any time.
      </p>

      <h2>6. Contact</h2>
      <p>
        If you have questions, contact support at support@yourapp.com
      </p>
    </div>
  );
}
